/*!
* @copyright
* Copyright(c) 2018 SICK AG
*/
const style = `* {
  box-sizing: border-box;
}

*,
:host {
  box-sizing: border-box;
  font-size: 1rem;
  font-family: inherit;
}

:host button,
:host input,
:host optgroup,
:host select,
:host textarea {
  font-family: inherit;
}

:host {
  display: inline-block;
  vertical-align: middle;
  width: 32.8571428571rem;
  min-width: 3.5714285714rem;
}
:host .label,
:host .report {
  font-size: inherit;
  color: #2C3133;
  color: var(--davinci-color-text, #2C3133);
}
:host .label {
  padding-bottom: 0.8571428571rem;
}
:host .report {
  padding-top: 0.5714285714rem;
}
:host .horizontal {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-content: flex-start;
  align-items: center;
}
:host .horizontal .bar-background {
  flex: 1 1 auto;
  height: 0.5714285714rem;
  width: 100%;
  position: relative;
  background: #C5CACC;
  background: var(--davinci-color-outline-light, #C5CACC);
  margin-right: 0.8571428571rem;
}
:host .horizontal .bar-background .bar-progress {
  height: 0.5714285714rem;
  position: relative;
  background-color: #007CC1;
  background-color: var(--davinci-color-primary, #007CC1);
}

.horizontal ::slotted(*) {
  flex: 0 0 auto;
}

:host([hidden]) {
  display: none;
}`;
export { style };
